// ブラウザを切り替えるコンポーネント.
import { detect } from 'detect-browser';
import * as React from 'react';
import { Firefox } from './Firefox';
import { Chrome } from  './Chrome';
import { InternetExplorer } from  './InternetExplorer';
import { Edge } from  './Edge';
import { Safari } from  './Safari';
import { Default } from  './Default';

// 居宅訪問チェックシート.
interface BrowserHandlerProps extends React.Props<{}> {
  // 親から渡された.
  moffAPI: any;
  total: number;
}

export class BrowserHandler extends React.Component<BrowserHandlerProps, {}> {
  render() {
    const browser = detect();
    if (browser) {
      const name: string = browser.name;
      switch (name) {
        case 'ie':
          return <InternetExplorer moffAPI={this.props.moffAPI} total={this.props.total} />;
        case 'firefox':
          return <Firefox moffAPI={this.props.moffAPI} total={this.props.total} />;
        case 'chrome':
          return <Chrome moffAPI={this.props.moffAPI} total={this.props.total} />;
        case 'safari':
          return <Safari moffAPI={this.props.moffAPI} total={this.props.total} />;
        case 'edge':
          return <Edge moffAPI={this.props.moffAPI} total={this.props.total} />;
        default:
          return <Default moffAPI={this.props.moffAPI} total={this.props.total} />;
      }
    }

    // 安全策.
    return <Default moffAPI={this.props.moffAPI} total={this.props.total} />;
  }
}


// WEBPACK FOOTER //
// ./src/components/HomeVisitPrintBrowsers/BrowserHandler.tsx